import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Card = styled(Link)`
  display: block;
  width: 100%;
`;

export const Layout = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 100px auto;
  column-gap: 12px;
  align-items: start;
`;

export const Image = styled.div`
  background: ${p => p.theme.palette.gray[100]};
  position: relative;
  padding-top: 125%;

  img {
    position: absolute;
    top: 0;
    display: block;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.3px;
  color: ${p => p.theme.palette.text.high};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChipRow = styled.div`
  margin-top: 4px;
`;

export const Description = styled.div`
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 148%;
  letter-spacing: 0.17px;
  color: ${p => p.theme.palette.text.low};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  p {
    margin: 0;
  }
`;

export const SkeletonBlock = styled.div`
  background: ${p => p.theme.palette.gray[100]};
  border-radius: 4px;
`;
